export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14820.e09d4da0.jpg";